export interface IConsultationRequestState {
  activeStep: EActiveConsultationModal | null;
  serviceBottomOffset?: number;
}

export enum EActiveConsultationModal {
  'ChoosingConsultationType' = 'choosingConsultationType',
  'EmailForm' = 'emailForm',
  'PhoneForm' = 'phoneForm',
}
